import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data" : []
}

const messageDataSlice = createSlice({
    name:'messageData',
    initialState,
    reducers : {
        messageData: (_state,payload)=>{
            return {
                "id" : uuidv4(),
                "data": payload.payload
            }
        },resetMessageData:(_state,payload)=>{
            return initialState
        }
    }
});

export default messageDataSlice.reducer
export const messageData = messageDataSlice.actions.messageData
export const resetMessageData = messageDataSlice.actions.resetMessageData

